import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import { getOrderFormIsClickCollectOrderSelector } from '@redux/reducers/order-form/orderFormSelector';
import { getPaymentProcessingSelector, getSelectedPaymentTypeSelector } from '@redux/reducers/payment/paymentSelector';
import { isZeroAmount } from '@utils/index';

const getIsZeroOutstandingBalanceSelector = (state: RootState) =>
  isZeroAmount(state?.orderForm?.amounts?.outstandingBalance) ?? false;

const paymentButtonState = createSelector(
  [
    getOrderFormIsClickCollectOrderSelector,
    getPaymentProcessingSelector,
    getSelectedPaymentTypeSelector,
    getIsZeroOutstandingBalanceSelector,
  ],
  (isClickCollectOrder, paymentProcessing, selectedPaymentType, isZeroOutstandingBalance) => ({
    isClickCollectOrder,
    isZeroOutstandingBalance,
    paymentProcessing,
    selectedPaymentType,
  }),
);

export default paymentButtonState;
